module.exports = __webpack_public_path__ + "img/toLearnpic_pdf.bd06710d.png";